import { Component } from '@angular/core';
import { ToggleThemeService } from '@corporate-tailwind/widget';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-confirm-email-ok',
    imports: [TranslateModule],
    templateUrl: './confirm-email-ok.component.html',
    styleUrl: './confirm-email-ok.component.scss'
})
export class ConfirmEmailOkComponent {

    constructor(
        public _toggleThemeService: ToggleThemeService
    ) {}

    ngOnInit(): void {
        // Initialize theme and direction on component load
        this._toggleThemeService.initializeTheme();
    }

    // Toggle theme between light and dark
    toggleTheme() {
        this._toggleThemeService.toggleTheme();
    }

    // Toggle direction between LTR and RTL
    toggleDirection() {
        this._toggleThemeService.toggleDirection();
    }

    closeWindow() {
        window.close();
    }

}